// src/components/Home.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Navbar, Container, Nav, Button, Table, Card, Modal, Form, Spinner, Alert } from 'react-bootstrap';


const AdmitDownload = () => {
  const navigate = useNavigate();


  const [forms, setForms] = useState([]);
  const [user, setUser] = useState("");

  const handleFormsClick = () => {
    navigate("/home");
  };
  const handleExit = () => {
    navigate("/");
  };
  const handleProfileClick = async ()=>{
    console.log("Go to profile")
    navigate("/profile")
  }
  useEffect(() => {
    // Fetch the list of forms using Axios (replace the URL with your actual endpoint)
    axios.get(`/api/getAdmitList`)
      .then(response => {
        // Check if the response data is an array or an object
        console.log("Form list fetched")
        if( response.data){
          if(response.data.message){
            toast.error(response.data.message)
            navigate("/");
          }
          if (Array.isArray(response.data)) {
            setForms(response.data);
            if(response.data[0]){
              setUser(response.data[0].phone)
            }else{
              setUser(response.data.phone)
              console.log("no forms")
            }

          }
          else {
            setUser(response.data.Phone)
            console.error('Invalid response format:', response.data);
          }
      }
      })
      .catch(error => {
        console.error('Error fetching forms:', error);
        navigate("/");
      });
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' , padding: '15px',backgroundColor:"#06213f"}}>
        <img src="/logo_0.png" alt="Header Image" style={{ height: '100px', backgroundColor:"#06213f"}} />
      </div>
      <Navbar variant="dark" style={{ backgroundColor: '#06213f'}}>
        <Container>
          <Navbar.Brand href="/home">Ladakh Police Constable Recruitment 2026</Navbar.Brand>
          <Nav className="me-auto">
            {/*
            <Nav.Link onClick={handleFormsClick}>Application Forms</Nav.Link>
            <Nav.Link onClick={console.log("admit click..")}>Download Admit Cards</Nav.Link>
            <Nav.Link onClick={handleProfileClick}>Profile</Nav.Link>
            */}

          </Nav>
        </Container>
      </Navbar>

      <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#dee0d7', padding: '20px' , height: '100vh' }}>


      <Card className="shadow-sm" style={{ borderColor: "#000", maxWidth: "80rem", width: '100%', height: '90%' }}>
      <Card.Body>
      <center>
        <br></br>
        <h2 className="mb-4" style={{ fontWeight: 'bold' }}>Admit Cards</h2>
      </center>
      {forms.length === 0 ? (
        <p className="container mt-5" style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold'}}>No Applications were submitted</p>
      ) : (
        <div className="container mt-5">
          <Table striped bordered hover>
          <thead>
            <tr>
              <th>Rollno</th>
              <th>Name</th>
              <th>Center</th>
              <th>Exam Date</th>
              <th>Shift</th>
              <th>Reporting Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {forms.map((form, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/admit-details/${form.rollno}`}>
                    {form.rollno}
                  </Link>
                </td>
                <td>{form.name}</td>
                <td>{form.petcenter}</td>
                <td>{form.date_of_exam}</td>
                <td>{form.shift}</td>
                <td>{form.reporting_time}</td>
                <td>
                  <Button
                    variant="primary"
                    style={{ backgroundColor: '#06213f'}}
                    onClick={() => navigate(`/admit-details/${form.rollno}`)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        </div>
      )}
        <div style={{ display: 'flex', justifyContent: 'center'}}>
          {//<Button onClick={handleNewForm}style={{ marginRight: '10px', backgroundColor: '#406666'}} variant="primary">Apply for a new Post</Button>{' '}
          }<Button onClick={handleExit} variant="danger">LOGOUT</Button>{' '}
        </div>

      </Card.Body>
        </Card>
        </div>

    </div>
  );
};

export default AdmitDownload;
